<template>
  <div :class="['input-block', { 'error': error }]">
    <div :class="['input-field date']">
      <label
        v-if="label.length"
        v-dompurify-html="fieldLabel"
      />
      <div class="fields">
        <span class="field">
          <input-base
            ref="date"
            type="text"
            name="date"
            field="date"
            aria-label="DD.MM.YYYY"
            :value="value"
            :mask-value="'## / ## / ####'"
            :disable="dateDisabled"
            :class="{ 'not-empty': value !== '' }"
            :placeholder="$t('reusable.dateFormat')"
            @input="onDateChange($event)"
          />
        </span>
      </div>
    </div>
    <div
      v-if="hint"
      class="hint"
    >
      {{ hint }}
    </div>
    <errors
      v-if="error"
      :errors="errorMsg"
    />
  </div>
</template>

<script>
import InputBase from 'components/Elements/Base/Input'

export default {
  name: "Date",
  components: {
    InputBase,
    Errors: () => import(/* webpackChunkName: "element-errors" */ 'components/Elements/Errors')
  },
  props: {
    optional: {
      type: Boolean,
      default: false
    },
    label: {
      type: String,
      default: '',
      required: false
    },
    errorField: {
      type: Boolean,
      default: false,
      required: false
    },
    errorMsgField: {
      type: String,
      default: '',
      required: false,
    },
    value: {
      type: String,
      required: true
    },
    dateDisabled: {
      type: Boolean,
      default: false
    },
    hint: {
      type: String,
      default: '',
      required: false
    },
  },
  computed: {
    fieldLabel () {
      let label = this.label

      if (this.optional) {
        label += `<span> (${this.$t('optional')})</span>`
      }

      return label
    },
    error () {
      return this.errorField
    },
    errorMsg () {
      const error = [];

      error.push(this.errorMsgField)

      return error;
    }
  },
  methods: {
    onDateChange (value) {
      this.$emit('input', value)
    }
  }
}
</script>

<style lang="scss" scoped rel="stylesheet/scss">
@import "~assets/styles/common.scss";

.input-block {
  display: block;

  .input-field {
    display: flex;
    flex-direction: row;
    background: white;
    border-radius: 4px;
    box-sizing: border-box;
    border: 1px solid $blue-border;
    height: 58px;
    margin-bottom: 8px;
    position: relative;

    @include bp-mf-tablet {
      max-width: 252px;
    }

    &:focus-within {
      border-color: $blue-medium;
    }

    label {
      position: absolute;
      left: 0;
      padding: 0 16px;
      width: 100%;
      transition: 0.2s ease all;
      @include text-overflow();
      pointer-events: none;
      color: $blue-light;
      top: 7px;
      font-size: em(12);
      letter-spacing: 0;
      line-height: 14px;
    }

    .fields {
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      padding: 24px 48px 0 16px;

      @include bp-mf-tablet {
        padding: 24px 16px 0;
      }

      .field {
        width: 100%;
        position: relative;
        display: inline-block;

        &:after {
          right: 10px;
          position: absolute;
          top: calc(50% - 15px);
          content: '/';
          display: inline-block;
          width: 10px;
          color: $blue-light;
          font-size: em(16);
        }

        &:last-child:after {
          content: '';
        }

        input {
          width: calc(100% - 20px);
          height: 21px;
        }
      }
    }
  }

  &.error {

    .input-field {
      border: 1px solid $red-error;
      margin-bottom: 6px;
    }
  }

  .hint {
    color: $blue-light;
    font-size: em(12);
    line-height: 14px;
    margin-bottom: 16px;

    @include bp-mf-tablet {
      margin-bottom: 12px;
    }
  }

  &.compact {
    .input-field {
      height: 48px;
    }

    .fields {
      padding: 14px;
    }
  }
}

</style>
